export const stringifyStoreId = (storeId?: string | number) =>
    storeId ? `${storeId.toString().padStart(4, '0')}` : undefined;

export const stripStoreId = (storeId?: string) =>
    storeId?.length && storeId?.length > 1
        ? storeId?.replace(/^0+/, '')
        : storeId;
